<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="showAllProducts"

    :max="max"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Merk"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :exportParams="exportEndpointParams"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addBrand"
          >
            Merk toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded" #row-action="{ item }">
      <TableActionDropdown
        class="drop"
        :item="item"
        :options="options(item, freshRefetch)"
      />
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen merken"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z" clip-rule="evenodd" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"

export default {
  metaInfo: {
    title: "Merken",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    TableHeader,
    TableActionDropdown,
    RefreshBtn,
    EmptyStatePlaceholder,
    HeaderButton,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'brands',
      page_size: 100,
      params: {
        name: "",
        sku: null,
        price: 0,
        website: "",
        search: "",
      },
      route: "/api/brands",
    }),
  ],
  methods: {
    addBrand() {
      this.$pushModal({
        modal: "EditBrand",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    editBrand(brand) {
      this.$pushModal({
        modal: "EditBrand",
        toBind: {
          brand: this.tableResult.find(item => item.uid === brand.uid),
          callback: this.freshRefetch,
        },
      })
    },
    showAllProducts(brand) {
      this.$router.push(`/admin/all-products?brands=%255B%2522${brand.uid}%2522%255D`)
    },
    async deleteBrand(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/brands/${uid}`)
      )
      this.$store.dispatch('clearCacheSearch', "brands")
      this.$success("Productgroup succesvol verwijderd!")
      this.freshRefetch()
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteBrand(item.uid),
        {
          title: "Productgroup verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> product group?`,
          buttonSave: "Verwijderen",
        }
      )
    },
    options(item, freshRefetch) {
      return [
        {
          click: () => this.editBrand(item),
          id: "update-table-element",
          name: "Merken bijwerken",
          icon: "nc-icon nc-ruler-pencil",
        },
        {
          click: () => this.confirmDelete(item, item.uid, freshRefetch),
          id: "delete-table-element",
          name: "Merken verwijderen",
          icon: "nc-icon nc-simple-remove",
        },
      ];
    },
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Naam']
    },
    websiteColumnVariables() {
      return ['name']
    },
    capitalize() {
      return [false]
    },
  },
}

</script>
